import axios from 'axios';

import merge from 'lodash/merge';
import clone from 'lodash/clone';

import LanguageHeader from '../../../lang/interceptors/LanguageHeader';

const TOKEN_URL = 'oauth/token';
const SCOPE = '';
const APP_GRANT_TYPE = 'client_credentials';
const USER_GRANT_TYPE = 'password';
const REFRESH_GRANT_TYPE = 'refresh_token';
const CLIENT_ID = process.env.CLIENT_ID;
const DATAPICKER = process.env.DATAPICKER;
const CLIENT_SECRET = process.env.CLIENT_SECRET;

const DEFAULT_DATA = {
  scope: SCOPE,
  client_id: CLIENT_ID,
  client_secret: CLIENT_SECRET,
  datapicker: DATAPICKER,
};

class Manager {
  constructor() {
    let http = axios.create({
      baseURL: process.env.APP_URL,
    });
    LanguageHeader(http);
    this.$http = http;
  }

  makeRequest(params = {}) {
    return this.$http.post(TOKEN_URL, merge(
        clone(DEFAULT_DATA),
        params,
    ));
  }

  getAppToken() {
    return this.makeRequest({grant_type: APP_GRANT_TYPE});
  }

  getUserToken({username, password}) {
    return this.makeRequest({
      grant_type: USER_GRANT_TYPE,
      username,
      password,
    });
  }

  refresh(refreshToken) {
    return this.makeRequest({
      grant_type: REFRESH_GRANT_TYPE,
      refresh_token: refreshToken,
    });
  }
}

export default Manager;


// WEBPACK FOOTER //
// ./src/common/auth/api/Manager.js